import moveItemsFromItemIds from 'owa-mail-triage-action/lib/actions/move/moveItemsFromItemIds';
import moveMailListRowsHelper from './helpers/moveMailListRowsHelper';
import { ActionSource } from 'owa-analytics-actions';
import { getRowIdsFromRowKeys, TableView } from 'owa-mail-list-store';

/**
 * The action worker which handles moving conversations.
 * @param conversationIds - the conversations that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the conversations are moving from
 */
export default function moveItems(
    rowKeys: string[],
    destinationFolderId: string,
    originalTableView: TableView,
    actionSource: ActionSource
) {
    return moveMailListRowsHelper(
        rowKeys,
        destinationFolderId,
        originalTableView,
        moveItemsInternal,
        actionSource
    );
}

/**
 * The move items internal method
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
function moveItemsInternal(
    rowKeys: string[],
    destinationFolderId: string,
    originalTableView: TableView,
    actionSource: ActionSource
): Promise<void> {
    const itemIdStrings = getRowIdsFromRowKeys(rowKeys, originalTableView.id);
    return moveItemsFromItemIds(
        itemIdStrings,
        destinationFolderId,
        originalTableView,
        actionSource
    );
}
